<template>
  <main-layout>
    <!-- <pre> password {{ $v.postAddress }}</pre> -->
    <!-- <pre> passwordConfirm {{ $v.passwordConfirm }}</pre> -->
    <div class="container-fluid light-grey-bg no-padding">
      <div class="menu-content-box">
        <h1>Meus planos</h1>
        <current-plan-item :mySubscriptionList="mySubscriptionList"></current-plan-item>
      </div>
      <div class="my-plans menu-content-box">
        <h2 class="title-bigger">Alterar plano</h2>
        <h2 style="padding-top: 30px" v-if="companyFreePlan._id || companyPlan._id">Empresarial</h2>
        <div class="light-grey-bg" style="margin-top: 25px;" v-if="companyFreePlan._id || companyPlan._id">
          <div class="row" style="padding: 4px 0px;">
            <div class="col-md-6 no-padding-left-m" style="padding-right: 2px; padding-left: 0px;">
              <!-- company free -->
              <plan-item :isSubscribed="2" :freePlans="companyFreePlan"></plan-item>
            </div>
            <div class="col-md-6 no-padding-right-m" style="padding-left: 2px">
              <!-- company paid -->
              <plan-item :isSubscribed="companyIsPaid" :paidPlans="companyPlan"
                :subscribedPlan="subscribedCompanyPlan"></plan-item>
            </div>
          </div>
        </div>
        <!-- <h2 style="padding-top: 30px">Afiliado</h2>
        <div class="light-grey-bg">
          <div class="row" style="padding: 4px 0px; margin-top: 25px">
            <div class="col-md-6" style="padding-right: 2px">
              <plan-item :isSubscribed="2" :freePlans="afiliateFreePlan"></plan-item>
            </div>
            <div class="col-md-6" style="padding-left: 2px">
              <plan-item :isSubscribed="afiliateIsPaid" :paidPlans="afiliatePlan" :subscribedPlan="subscribedAfiliatePlan"></plan-item>
            </div>
          </div>
        </div> -->

      </div>
      <subscription-history :subscriptionList="subscriptionList"></subscription-history>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "../../../layouts/CompanyProfile.vue";
// import MainLayout from "../../../layouts/Salesman.vue";
import userMixin from "../../../mixins/userMixin.js";
import PlanItem from "../../../components/PlanItem.vue";
import CurrentPlanItem from "../../../components/CurrentPlanItem.vue";
import SubscriptionHistory from "../../../components/SubscriptionHistory.vue";
import moment from "moment";
import { server, local } from "../../../js/variables.js";
import { required, email, sameAs } from "vuelidate/lib/validators";

const link = "/static/img/produto.png";

export default {
  mixins: [userMixin],
  components: {
    MainLayout,
    PlanItem,
    CurrentPlanItem,
    SubscriptionHistory,
  },
  data() {
    return {
      isPaid: 0,
      companyIsPaid: 0,
      afiliateIsPaid: 0,
      companyPlan: {},
      afiliatePlan: {},
      companyFreePlan: {},
      afiliateFreePlan: {},
      subscribedCompanyPlan: {},
      subscribedAfiliatePlan: {},
      mySubscriptionList: [],
      subscriptionList: [],
    };
  },
  validations: {},
  mounted() {
    var parameters = this.$route.query;
    let self = this;
    self.getPlans();
  },
  watch: {
    user(newValue, oldValue) {
      // console.log(newValue, oldValue);

      if(local.subscriptionList){
        this.mySubscriptionList = local.subscriptionList;
        for(let subscription of local.subscriptionList){
          if(subscription.plan.type == 'COMPANY'){
            if(subscription.plan.payment_option.length > 0){
              this.companyIsPaid = 1;
              // console.log('AQUI', subscription)
              this.subscribedCompanyPlan = subscription;
              
            }else{
              this.companyIsPaid = 0;
            }
          }
          // else if(subscription.plan.type == 'AFILIATE'){
          //   if(subscription.plan.name == 'Plano Afiliado'){
          //     this.afiliateIsPaid = 1;
          //     this.subscribedAfiliatePlan = subscription;
          //   }else{
          //     this.afiliateIsPaid = 0;
          //   }
          // }
        }
      }
      
      if(this.user._id) {
        this.getSubscriptions();
      }
    },
  },
  methods: {
    getPlans() {
      let self = this;
      // if (!localStorage.token) {
      //     return
      // }
      // server.config.headers = {
      //     Authorization: 'Bearer ' + localStorage.token
      // }
      this.axios
        .get(server.url + "/api/plan?is_enable=true", server.config)
        .then(function (response) {
          let responseData = response.data.data;
          self.planList = responseData.plan_list;
          for (let plan of self.planList) {
            if (plan.type == "COMPANY" && plan.payment_option.length > 0) {
              self.companyPlan = plan;
            } else if (plan.type == "AFILIATE" && plan.payment_option.length > 0) {
              self.afiliatePlan = plan;
            } else if (plan.type == "COMPANY" && plan.payment_option.length == 0) {
              self.companyFreePlan = plan;
            } else if (plan.type == "AFILIATE" && plan.payment_option.length == 0) {
              self.afiliateFreePlan = plan;
            }
          }
          for (let payment of self.companyPlan.payment_option) {
            if (payment.interval == 1) {
              self.companyPlan.payment_1 = payment;
            }
            if (payment.interval == 3) {
              self.companyPlan.payment_3 = payment;
            }
            if (payment.interval == 6) {
              self.companyPlan.payment_6 = payment;
            }
            if (payment.interval == 12) {
              self.companyPlan.payment_12 = payment;
            }
          }

          for (let payment of self.afiliatePlan.payment_option) {
            if (payment.interval == 1) {
              self.afiliatePlan.payment_1 = payment;
            }
            if (payment.interval == 3) {
              self.afiliatePlan.payment_3 = payment;
            }
            if (payment.interval == 6) {
              self.afiliatePlan.payment_6 = payment;
            }
            if (payment.interval == 12) {
              self.afiliatePlan.payment_12 = payment;
            }
          }
        })
        .catch(function (error) {
          self.output = error;
          self.showError(error);
        });
    },
    getSubscriptions() {
      let self = this;
      if (!localStorage.token) {
          return
      }
      server.config.headers = {
          Authorization: 'Bearer ' + localStorage.token
      }

      let header = JSON.parse(JSON.stringify(server.config));
      header["params"] = {
        user: this.user._id,
      };

      this.axios.get( server.url + '/api/subscription', header)
      .then(function (response) {
        let responseData = response.data.data;
        self.subscriptionList = responseData.subscription_list;
        let array = [];

        for(let subscription of self.subscriptionList){
          if(subscription.plan_payment){
            array.push(subscription);
          }
        }

        self.subscriptionList = array.sort(function(a,b){
          return new Date(b.created_at) - new Date(a.created_at);
        });

        for(let subscription of self.subscriptionList){
          let date = self.fixOneDate(subscription.created_at);
          subscription.created_at = date;
        }
        
      })
      .catch(function (error) {
        self.output = error;
        self.showError(error);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "../../../scss/reset.scss";
// @import "../../../scss/base.scss";

.banner {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
}

.profile {
  min-height: 100vh;

  .user-img {
    // position: absolute;
    // left: 50%;
    // margin-left: -69px;
    // top: 103px;
  }

  .profile-bg {
    height: 116px;
    width: 130px;
    margin: auto;
    margin-top: 70px;
    margin-bottom: 70px;
  }
}

.my-plans {
  position: relative;

  .title-bigger {
    font-size: 30px;
  }

}


@media only screen and (max-width: 600px) {
  .my-plans {}
}
</style>
